export default defineNuxtPlugin({
  // Makes sure that your plugin is executed after this plugin.
  // If it were to run before, then `state` would be null.
  dependsOn: ['nuxt-graphql-middleware-provide-state'],
  setup() {
    const state = useGraphqlState()

    // This is nullable because it's injected by a plugin.
    if (!state) {
      return
    }

    const headers: any = {}
    const token = useCookie('sessionid')
    if (token) {
      headers['Cookie'] = `sessionid=${token.value}`
    }

    // Set fetch options for all GraphQL queries and mutations.
    state.fetchOptions = {
      headers,
    }
  },
})
